import * as React from 'react';
import moment, { Moment } from 'moment-timezone';
import { ISODateTime, TimeRange } from '../../types/date';

type DateProps = {
    date: ISODateTime | Moment;
};
export const SimpleDate = ({ date }: DateProps) => <span>{moment(date).format('M月D日')}</span>;
export const DetailedDate = ({ date }: DateProps) => <span>{moment(date).format('YY年M月D日')}</span>;
export const DetailedDate2 = ({ date }: DateProps) => <span>{moment(date).format('YYYY/MM/DD')}</span>;

type RangeProps = {
    range: TimeRange;
};

export const SimpleTimeRange = ({ range }: RangeProps) => (
    <span>
        {moment(range.starts_at).format('HH時mm分')}
        〜
        {moment(range.ends_at).format('HH時mm分')}
    </span>
);

export const DetailedDateTime = ({ date }: DateProps) => <span>{moment(date).format('YYYY年M月D日 HH時mm分')}</span>;

export const SimpleDateRange = ({ fromDate, toDate }) => (
    <span>
        {moment(fromDate).format('MM月DD日')}
        〜
        {moment(toDate).format('MM月DD日')}
    </span>
);

export const SimpleDateRange2 = ({ fromDate, toDate }) => (
    <span>
        {moment(fromDate).format('YYYY年M月D日')}
        〜
        {toDate && moment(toDate).format('M月D日')}
    </span>
);

export const DetailedDateRange = ({ fromDate, toDate }) => (
    <span>
        {moment(fromDate).format('YYYY年M月D日')}
        〜
        {toDate && moment(toDate).format('YYYY年M月D日')}
    </span>
);
